import mixpanel, { type FlagsConfig } from 'mixpanel-browser';

import { getAppPlatform } from 'src/native/appInfo';
import { parseWebVersion } from 'src/utils/webVersion';

const TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN;
const FLAGS_PERSISTENCE_TTL_MS = 24 * 60 * 60 * 1000;

/** Events only: flags still load, so the dev server reads the dev project's flags without tracking. */
export const IS_MIXPANEL_DISABLED = !import.meta.env.PROD || !TOKEN;

/** Runs before the first render, because the login page reads flags before any provider mounts. */
export function initMixpanel() {
    const { code, name } = parseWebVersion(import.meta.env.VITE_VERSION);
    const flags: FlagsConfig = {
        context: {
            custom_properties: {
                env: import.meta.env.VITE_ENV,
                platform: getAppPlatform(),
                web_version: name,
                web_version_code: code,
            },
        },
        persistence: {
            variantLookupPolicy: 'persistenceUntilNetworkSuccess',
            persistenceTtlMs: FLAGS_PERSISTENCE_TTL_MS,
        },
    };

    mixpanel.init(TOKEN, { flags: TOKEN ? flags : false });
    // Make mixpanel available on window for Chameleon integration
    window.mixpanel = mixpanel;

    if (IS_MIXPANEL_DISABLED) {
        mixpanel.disable();
    }
}
